<template>
  <el-dialog
    :title="title"
    :visible="true"
    width="500px"
    :close-on-click-modal="false"
    @close="$router.replace('/lists')"
  >
    <el-form
      ref="priceTypeForm"
      v-loading="loading"
      :model="priceType"
      :rules="rules"
      label-position="top"
      autocomplete="off"
      @submit.native.prevent="add"
    >
      <el-form-item
        prop="name"
        label="Név"
        :error="errors.name ? errors.name[0] : null"
      >
        <el-input v-model="priceType.name" />
      </el-form-item>
    </el-form>
    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click="$router.replace('/lists')">
        Mégse
      </el-button>
      <el-button
        type="primary"
        :loading="buttonLoading"
        @click="add"
      >
        {{ buttonText }}
      </el-button>
    </div>
  </el-dialog>
</template>
<script>
  export default {
    props: ['type', 'priceTypeId'],
    data() {
      return {
        loading: false,
        errors: {
          name: null,
        },
        buttonLoading: false,
        priceType: {},
        rules: {
          name :[
            { required: true, message: 'Név megadása kötelező', trigger: 'blur' }
          ]
        }
      }
    },
    computed: {
      title() {
        if (this.type === 'add') {
          return 'Új ár típus';
        } else if (this.type === 'update') {
          return 'Ár típus módosítása';
        } else {
          return '';
        }
      },
      buttonText() {
        if (this.type === 'add') {
          return 'Hozzáadás';
        } else if (this.type === 'update') {
          return 'Módosítás';
        } else {
          return '';
        }
      },
    },

    async mounted() {
      this.loading = true;
      if(this.priceTypeId) {
        this.priceType = await this.$store.dispatch('priceType/fetch', this.priceTypeId);
      }
      this.loading = false;
    },

    methods: {
      async add() {
        this.$refs['priceTypeForm'].validate(async valid => {
          if(valid) {
            this.buttonLoading = true;
            this.errors.name = null;
            try {
              if (this.type === 'add') {
                await this.$store.dispatch('priceType/add', this.priceType);
              } else if (this.type === 'update') {
                await this.$store.dispatch('priceType/update', this.priceType);
              }
              this.$store.dispatch('priceType/fetchAll');
              this.buttonLoading = false;
              this.$router.replace('/lists');
            } catch (e) {
              if (e.data && e.data.errors) {
                this.errors = e.data.errors;
              }
            }
            this.buttonLoading = false;
          }
        });
      }
    }
  }
</script>
